import React from 'react';
import { CheckCircle } from 'lucide-react';

export default function DealRoomApplication() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center px-4">
      <div className="text-center max-w-2xl">
        <div className="mb-8 flex justify-center">
          <CheckCircle className="w-24 h-24 text-cyan-400" strokeWidth={1} />
        </div>
        <h1 className="text-5xl font-light text-white mb-6 tracking-tight">Thank You for Your Interest</h1>
        <p className="text-xl text-slate-300 mb-8 leading-relaxed">
          The application period for the AEON-DEREE Deal Room has ended.
        </p>
        <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-8">
          <p className="text-slate-400 leading-relaxed">
            We appreciate your interest in our scholarship program. Applications are no longer being accepted at this time.
          </p>
        </div>
      </div>
    </div>
  );
}
